/*
  publicな情報なので公開しても問題ない
  環境によって異なるためCD導入後に環境変数として管理する
*/
export default {
  cognito: {
    userPoolClientId: "6b9acpcte8jn4k66abef15iuge",
    userPoolId: "ap-northeast-1_nKbdBHWuW",
  },
  apiUrl: "https://api.narichat2-dev.spiral-ai-app.com",
  // apiUrl: "http://localhost:8081",
  image: {
    maxSizeMB: 2,
  },
};
